// extracted by css-extract-rspack-plugin
export default {"cls1":"AccountMenuButton-cls1_p_-","cls2":"AccountMenuButton-cls2_Kr3 AccountMenuButton-cls1_p_-"};